import {cn} from '../../lib/utils';
import {Badge} from '../shadcn/badge';

import type {ComponentProps} from 'react';

export type CountBadgeProps = Omit<ComponentProps<typeof Badge>, 'size' | 'dot' | 'children'> & {
  count: number;
};

/** Round for a single digit; widens into a pill as the count grows. */
export function CountBadge({count, className, ...props}: CountBadgeProps) {
  return (
    <Badge
      variant="count"
      data-slot="count-badge"
      size="sm"
      className={cn(
        'h-5 min-w-5 justify-center px-1.5 py-0 text-caption leading-none font-semibold tabular-nums',
        className
      )}
      {...props}
    >
      {count}
    </Badge>
  );
}
